import common from '../common';

export default class DrawingTextureHackFrame {
	static create(path, center, rotation = 0) {
		const raster = path.rasterize();
		let texture = new PIXI.Texture.from(raster.canvas);
		if (rotation !== 0) {
			const holder = new PIXI.Container();
			const sprite = new PIXI.Sprite(texture);
			sprite.rotation = rotation;
			sprite.anchor.set(0.5);
			holder.addChild(sprite);
			texture = common.renderer.generateTexture(holder);
		}
		const to = new P3.Vector2(center.x - path.position.x, center.y - path.position.y);
		to.rotate(rotation);
		return new DrawingTextureHackFrame(texture,
			new PIXI.Point(0.5 + to.x / texture.width, 0.5 + to.y / texture.height));
	}

	constructor(texture, anchor) {
		this._texture = texture;
		this._anchor = anchor || new PIXI.Point(0.5);
	}

	get texture() {
		return this._texture;
	}

	get anchor() {
		return this._anchor;
	}
}